<learnmore-display
  [breadcrumbPre]="breadcrumbPre"
  [directoryPrefix]="getLearnmoreSection()"
></learnmore-display>